import 'css-chunk:src/feature/check-merge/CheckMergeModal.module.scss';export default {
  "content_wrapper": "CheckMergeModal_content_wrapper",
  "transferBar": "CheckMergeModal_transferBar",
  "filter_bar": "CheckMergeModal_filter_bar",
  "tableRow": "CheckMergeModal_tableRow",
  "tableRowSelected": "CheckMergeModal_tableRowSelected",
  "tableHeader": "CheckMergeModal_tableHeader",
  "radio": "CheckMergeModal_radio",
  "labelCol": "CheckMergeModal_labelCol"
};